@import "tailwindcss";

:root {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
  font-weight: 400;
  color-scheme: dark;
  background-color: #000000;
  color: #ffffff;
  scrollbar-color: #3f3f46 #000000;
  scrollbar-width: thin;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::selection {
  background-color: #ffffff;
  color: #000000;
}

body {
  margin: 0;
  display: flex;
  min-width: 320px;
  min-height: 100vh;
  background-color: #000000;
  color: #ffffff;
}

#root {
  width: 100%;
}

/* Balanced line breaks for standalone headings */
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

/* Prevent orphaned words in multi-line body copy */
p,
blockquote,
li {
  text-wrap: pretty;
}
